import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues, change } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';

import { NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_FORM_NAME } from 'Common/FormEnum';
import { TitledCard } from 'Components/';
import { NotificationAndDirectCertifiedLettersFieldEnum as Fields } from 'Common/FieldEnum';
import {
  DatePickerField,
  CheckboxField,
  SelectField,
  InputField,
} from 'Common/SemanticWrapper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { UseStudentAddressButtonGroup } from 'Common/Components/UseStudentAddressButtonGroup/UseStudentAddressButtonGroup';
import { YesNoOptions } from 'Common/FormHelper';
import { InputMode } from 'Common/FormEnum';

class NotificationAndDirectCertifiedLettersFormContainer extends Component {
  SortBy = [
    { value: 0, text: 'Parent Last Name, First Name' },
    { value: 1, text: 'Zip Code, Parent Last Name, Parent First Name' },
    { value: 2, text: 'Student Site ID, Teacher, Last Name, First Name' },
  ];

  ProvisionType = [
    { value: 0, label: 'Both' },
    { value: 1, label: 'CEP/Provision 2 Only ' },
    { value: 2, label: 'Traditional' },
  ];

  SelectByOptions = [
    { value: 0, label: 'Application Date' },
    { value: 1, label: 'Process Date' },
  ];
  LetterTypeOptions = [
    { value: 0, label: 'Notification' },
    { value: 1, label: 'Direct Certified' },
  ];
  PrintedOptions = [
    { value: 0, label: 'Unprinted' },
    { value: 1, label: 'Printed' },
  ];

  DirectCertifiedStatusOptions = [
    { value: 0, text: 'Active (2-4)' },
    { value: 1, text: 'Withdrawn (5)' },
    { value: 2, text: 'Both (2-5)' },
  ];
  NotificationLetterStatusOptions = [
    { value: 0, text: 'Active (2-4)' },
    { value: 1, text: 'Withdrawn (5)' },
    { value: 2, text: 'Both (2-5)' },
    { value: 3, text: 'Denied (4)' },
  ];

  IsEmailOptions = [
    { value: false, label: 'Print' },
    { value: true, label: 'Email' },
  ];

  EmailSource = [
    { value: 0, label: 'Household' },
    { value: 1, label: 'Student' },
  ];

  componentDidUpdate(prevProps) {
    // If the letter type is changed to Direct Certified and the denied status is selected
    // set the status to "both" via redux-form change()
    if (
      prevProps.formValues.LetterType !== this.props.formValues.LetterType &&
      this.props.formValues.LetterType === this.LetterTypeOptions[1].value
    ) {
      if (
        this.props.formValues.Status ===
        this.NotificationLetterStatusOptions[3].value
      ) {
        this.props.change(
          NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_FORM_NAME,
          Fields.Status,
          this.NotificationLetterStatusOptions[2].value
        );
      }
    }
  }

  render() {
    const { loading, disableEmail } = this.props;
    const { LetterType, IsEmail } = this.props.formValues;

    return (
      <Fragment>
        <Form name={NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_FORM_NAME}>
          <Grid>
            <TitledCard title={'Options'}>
              <Grid>
                <Grid.Row cols={3}>
                  <Grid.Column className="input-group--btn-group" width={5}>
                    <ReduxFormButtonGroup
                      formName={
                        NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_FORM_NAME
                      }
                      fieldName={Fields.LetterType}
                      name={Fields.LetterType}
                      options={this.LetterTypeOptions}
                      disabled={loading}
                      label={'Letter Type'}
                    />
                  </Grid.Column>
                  <Grid.Column className="input-group--btn-group" width={4}>
                    <ReduxFormButtonGroup
                      formName={
                        NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_FORM_NAME
                      }
                      fieldName={Fields.IsPrinted}
                      name={Fields.IsPrinted}
                      options={this.PrintedOptions}
                      disabled={loading}
                      label={'Print Options'}
                    />
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Field
                      label={'Max Number of Letters To Print'}
                      name={Fields.MaxNumberOfLettersToPrint}
                      component={InputField}
                      mode={InputMode.Integer}
                      maxLength={12}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </TitledCard>
            <TitledCard title={'Date Filters'}>
              <Grid>
                <Grid.Row cols={2}>
                  <Grid.Column className="input-group--btn-group" width={6}>
                    <ReduxFormButtonGroup
                      formName={
                        NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_FORM_NAME
                      }
                      fieldName={Fields.Selectby}
                      name={Fields.Selectby}
                      options={this.SelectByOptions}
                      disabled={loading}
                      label={'Select By'}
                    />
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Field
                      label={'Date Of Letter'}
                      name={Fields.DateOfLetter}
                      component={DatePickerField}
                      type="text"
                      openToDate={moment()}
                      disabled={loading}
                      maxDate={moment()}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={4}>
                    <Field
                      label={'From Date'}
                      name={Fields.FromDate}
                      component={DatePickerField}
                      type="text"
                      openToDate={moment()}
                      disabled={
                        loading || this.props.formValues[Fields.AllDates]
                      }
                      maxDate={moment()}
                    />
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Field
                      label={'To Date'}
                      name={Fields.ToDate}
                      component={DatePickerField}
                      type="text"
                      openToDate={moment()}
                      disabled={
                        loading || this.props.formValues[Fields.AllDates]
                      }
                      maxDate={moment()}
                    />
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Field
                      label={'All Dates'}
                      name={Fields.AllDates}
                      component={CheckboxField}
                      style={{ marginTop: 55 }}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Grid.Row />
            </TitledCard>
            <TitledCard title={'Filter By'}>
              <Grid>
                <Grid.Row>
                  <Grid.Column className="input-group--btn-group" width={3}>
                    <ReduxFormButtonGroup
                      formName={
                        NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_FORM_NAME
                      }
                      fieldName={Fields.ShowAdverseChangeOnly}
                      name={Fields.ShowAdverseChangeOnly}
                      options={YesNoOptions}
                      disabled={loading}
                      label={'Adverse Change Only'}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={4}>
                    <Field
                      component={SelectField}
                      name={Fields.Status}
                      options={
                        LetterType === 0
                          ? this.NotificationLetterStatusOptions
                          : this.DirectCertifiedStatusOptions
                      }
                      disabled={loading}
                      label={'Status'}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row cols={2}>
                  <Grid.Column className="input-group--btn-group" width={7}>
                    <ReduxFormButtonGroup
                      formName={
                        NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_FORM_NAME
                      }
                      fieldName={Fields.ProvisionType}
                      name={Fields.ProvisionType}
                      options={this.ProvisionType}
                      disabled={loading}
                      label={'Provision Type'}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Grid.Row />
            </TitledCard>
            <TitledCard>
              <Grid>
                <Grid.Row cols={3}>
                  <Grid.Column className="input-group--btn-group" width={3}>
                    <ReduxFormButtonGroup
                      formName={
                        NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_FORM_NAME
                      }
                      fieldName={Fields.ShowSiteName}
                      name={Fields.ShowSiteName}
                      options={YesNoOptions}
                      disabled={loading}
                      label={'Show Site Name'}
                    />
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <UseStudentAddressButtonGroup
                      formName={
                        NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_FORM_NAME
                      }
                      fieldName={Fields.UseStudentAddress}
                      name={Fields.UseStudentAddress}
                      disabled={loading}
                      label={'Use Student Address If Available'}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column className="input-group--btn-group" width={3}>
                    <ReduxFormButtonGroup
                      formName={
                        NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_FORM_NAME
                      }
                      fieldName={Fields.IsEmail}
                      options={this.IsEmailOptions}
                      label={'Action'}
                      disabled={disableEmail}
                    />
                  </Grid.Column>
                  {IsEmail && (
                    <Grid.Column className="input-group--btn-group" width={3}>
                      <ReduxFormButtonGroup
                        formName={
                          NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_FORM_NAME
                        }
                        fieldName={Fields.EmailSource}
                        options={this.EmailSource}
                        label={'Email Source'}
                        disabled={disableEmail}
                      />
                    </Grid.Column>
                  )}
                  <Grid.Column width={7}>
                    <Field
                      name={Fields.SortBy}
                      component={SelectField}
                      options={this.SortBy}
                      disabled={loading}
                      label={'Sort By'}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </TitledCard>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!moment(values[Fields.FromDate]).isValid()) {
    errors[Fields.FromDate] = 'Enter a valid From Date.';
  }
  if (!values[Fields.FromDate]) {
    errors[Fields.FromDate] = 'From Date must be set.';
  }

  if (!moment(values[Fields.ToDate]).isValid()) {
    errors[Fields.ToDate] = 'Enter a valid To Date.';
  }
  if (!values[Fields.ToDate]) {
    errors[Fields.ToDate] = 'To Date must be set.';
  }
  if (!moment(values[Fields.DateOfLetter]).isValid()) {
    errors[Fields.DateOfLetter] = 'Letter date must be set.';
  }

  if (values[Fields.IsEmail] && values[Fields.EmailSource] === undefined) {
    errors[Fields.EmailSource] = 'Email Source is required.';
  }

  if (
    moment(values[Fields.FromDate]).isValid() &&
    values[Fields.FromDate] &&
    moment(values[Fields.ToDate]).isValid() &&
    values[Fields.ToDate] &&
    moment(values[Fields.ToDate]).isBefore(values[Fields.FromDate])
  ) {
    errors[Fields.ToDate] =
      'To Date must be greater than or equal to From Date.';
  }

  return errors;
};

const mapStateToProps = state => {
  return {
    formValues: getFormValues(
      NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_FORM_NAME
    )(state),
    loading: false,
  };
};

const NotificationAndDirectCertifiedLettersForm = reduxForm({
  form: NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_FORM_NAME,
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(
  withRouter(
    connect(mapStateToProps, { change })(
      NotificationAndDirectCertifiedLettersFormContainer
    )
  )
);

export { NotificationAndDirectCertifiedLettersForm };



// WEBPACK FOOTER //
// ./src/pages/notificationanddirectcertifiedletters/components/NotificationAndDirectCertifiedLettersForm.js